import _ from 'lodash';
import getImageUrl from './get-image-url';

// eslint-disable-next-line max-params
export default function resolveUserImage(image, type, width, height, quality) {
  return _.isObject(image) ? getImageUrl(image, width, height, quality, type) : image;
}



// WEBPACK FOOTER //
// ./app/services/resolve-user-image.js